import { useContext } from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { Grid, useMediaQuery } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import IconsColor from '../../../../../components/utility/iconsColor';
import { primaryColor } from '../../../../../utils/colors';
import { currentActiveChatbotThreadTypeNew } from '../../../../../models/axiosModel';
import { hasInboxReadAccess } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import clsx from "clsx";

const ThreadTagComponent = () => {

    const { currentActiveChatbotThread, setFlagOpenThreadInfoBlock, flagOpenThreadInfoBlock, setFlagAssignThreadTagPopup } = useRuleBasedInboxStore(useShallow((state) => ({
        currentActiveChatbotThread: state.currentActiveChatbotThread,
        setFlagOpenThreadInfoBlock: state.setFlagOpenThreadInfoBlock,
        flagOpenThreadInfoBlock: state.flagOpenThreadInfoBlock,
        setFlagAssignThreadTagPopup: state.setFlagAssignThreadTagPopup,
    })))

    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;

    const laptopScreen = useMediaQuery('(max-width : 1600px) and (min-width : 1000px)')

    const isThreadTagAssigned = () => {
        if((currentActiveChatbotThread && currentActiveChatbotThread?.thread_tags && currentActiveChatbotThread?.thread_tags?.length > 0)){
            return true;
        }
        
        return false;
    }

    const onClickOfAddTag = () => {
        if(laptopScreen){
            setFlagOpenThreadInfoBlock(!flagOpenThreadInfoBlock);
        }
        setFlagAssignThreadTagPopup(true);
    }
    
    return (
        <>
            <Grid item mt={2} className={clsx(styles.userLastMessageEntries, styles.threadTagComponentGrid, globalStyles.fulwidth)}>
                <Grid container direction={"column"}> 
                    <Grid item xs={12} className={styles.threadTagTitleGrid}>
                        <Grid container gap={1} justifyContent={"space-between"}>
                            <Grid item className={styles.threadTagTitle}>
                                Tags
                            </Grid>
                            {(!isThreadTagAssigned() && hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail)) &&
                                <Grid item>
                                    <span className={clsx(globalStyles.primaryColor, globalStyles.clickable, styles.addTagStyles)} onClick={() => onClickOfAddTag()}>
                                        <IconsColor iconName='plus' width="15" height="15" fillColor={primaryColor} />
                                        Add
                                    </span>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    <Grid item className={clsx(styles.messageEntryValue, styles.threadTagCardGrid, globalStyles.fulwidth)}>
                        {isThreadTagAssigned() ?
                                <Grid container className={clsx(globalStyles.fulwidth, globalStyles.displayFlex)} gap={1} flexWrap={"wrap"}>
                                    {(currentActiveChatbotThread as currentActiveChatbotThreadTypeNew)?.thread_tags?.map((tag) => {
                                        return (
                                            <span className={styles.threadTagChipStyle} style={{ background: `${tag?.ticket_tag_color ?? primaryColor}` }}>
                                                {tag?.ticket_tag_name}
                                            </span>
                                        );
                                    })}
                                    {hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail) && 
                                        <Grid item className={globalStyles.clickable} onClick={() => onClickOfAddTag()}>
                                            <EditIcon className={styles.tagsEditIcon} />
                                        </Grid>
                                    }
                                </Grid>
                            :
                                <Grid item className={styles.messageEntryValue}>
                                    No tags assigned.
                                </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ThreadTagComponent
